import { useEffect, useState } from "react";
import OffreServices from "../../services/offre/offreServices";

function useOffres() {
  const [offres, setOffres] = useState([]);
  const [oneOffre, setOneOffre] = useState({});

// ✅ Fix
function fetchOffres() {
  return OffreServices.getAll()
    .then((res) => {
      if (Array.isArray(res.data.data)) {
        setOffres(res.data.data);
      } else {
        console.error("La réponse de l'API n'est pas un tableau.");
      }
    })
    .catch((err) => console.error("Erreur API :", err));
}
 
  const getOneOffre = (id, callback = () => {}) => {
    OffreServices.getOne(id)
      .then((res) => {
        setOneOffre(res.data);
        callback(res.data);
      })
      .catch((err) => console.error(err));
  };
  

  const createOffre = (data, callback = () => {}) => {
    OffreServices.create(data)
      .then(() => {
        fetchOffres();
        callback();
      })
      .catch((err) => console.error(err));
  };


  const updateOffre = (id, data, callback = () => {}) => {
    OffreServices.update(id, data)
      .then(() => {
        fetchOffres();
        callback();
      })
      .catch((err) => console.error(err));
  };

  const deleteOffre = (id, callback = () => {}) => {
    OffreServices.delete(id)
      .then(() => {
        fetchOffres();
        callback();
      })
      .catch((err) => console.error(err));
  };

  return { offres, oneOffre, createOffre, updateOffre, deleteOffre, getOneOffre,fetchOffres };
}

export default useOffres;
